export const Resumedata = [
    {
        id: 1,
        img: '/img/fa-solid_graduation-cap.png',
        school: 'Ambrose Alli University Ekpoma',
        degree: 'Bachelor of Engineering in Civil Engineering(BENGCIE)',
        year: 'Enter into the university in 2022'
    },
    {
        id: 2,
        img: '/img/fa-solid_graduation-cap.png',
        school: 'FreeCodeCamp.org',
        degree: `Learnt the basics of all responsive designs in Responsive Web Design.You can take a look at my certificate here.`,
        link: 'https://www.freecodecamp.org/certification/Izekorpaul/responsive-web-design',
        button: <button className="portfolio-cert">
            <a href="https://www.freecodecamp.org/certification/Izekorpaul/responsive-web-design" target="_blank">
                Certification
            </a>
        </button>,
        year: 'November 17, 2021'
    },
    {
        id: 3,
        img: '/img/fa-solid_graduation-cap.png',
        school: 'FreeCodeCamp.org',
        degree: `Learnt the basics to intermediate javascript,Which has become a part of my language, You can view my certificate here`,
        link: 'https://www.freecodecamp.org/certification/Izekorpaul/javascript-algorithms-and-data-structures',
        button: <button className="portfolio-cert">
            <a href="https://freecodecamp.org/certification/Izekorpaul/javascript-algorithms-and-data-structures" target="_blank">
                Certification
            </a>
        </button>,
        year: 'May 7, 2022'
    },
    {
        id: 4,
        img: '/img/fa-solid_graduation-cap.png',
        school: 'Zuri Intership',
        degree: 'Finalist in the zuri internship',
        year: 'December 2022',
        cert: 'Awaiting Certificate'
    }
]